import { SourceTypeEnum } from '../../../api/source/enums/source-type.enum';
import { SourceApi } from '../../../api/source/models/source-api.model';
import { SourceChip } from './source-chip.model';
import { BaseModel } from '@Common/Basic/models/base.model';

export class Source extends BaseModel<Source, SourceApi> {
    id: number;
    name: string;

    accountId: number;
    type: SourceTypeEnum;

    createdByUserId: number;
    createdDate: Date;

    lastModifiedByUserId: number;
    lastModifiedDate: Date;

    private typeToStringMap = {
        [SourceTypeEnum.journalist]: '(CON)',
        [SourceTypeEnum.outlet]: '(OUT)',
        [SourceTypeEnum.url]: '(URL)',
    };

    constructor(apiModel?: SourceApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: SourceApi) {
        this.id = apiModel.id;
        this.accountId = apiModel.accountId;
        this.name = apiModel.text.replace(/["]+/g, '');
        this.type = apiModel.type;
        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = new Date(apiModel.createdDate);
        this.lastModifiedByUserId = apiModel.lastModifiedByUserId;
        this.lastModifiedDate = new Date(apiModel.lastModifiedDate);
    }

    constructDefault() {
        this.name = '';
    }

    toApiModel(): SourceApi {
        return {
            id: this.id,
            accountId: this.accountId,
            text: JSON.stringify(this.name),
            type: this.type,
            createdByUserId: this.createdByUserId,
            createdDate: +this.createdDate,
            lastModifiedByUserId: this.lastModifiedByUserId,
            lastModifiedDate: +this.lastModifiedDate
        };
    }

    clone(): Source {
        return new Source(this.toApiModel());
    }

    equals(other?: Source): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        if (this.accountId !== other.accountId) {
            return false;
        }

        if (this.type !== other.type) {
            return false;
        }

        if (this.createdByUserId !== other.createdByUserId) {
            return false;
        }

        if (this.createdDate !== other.createdDate) {
            return false;
        }

        if (this.lastModifiedByUserId !== other.lastModifiedByUserId) {
            return false;
        }

        if (this.lastModifiedDate !== other.lastModifiedDate) {
            return false;
        }

        return true;
    }

    /**
     * Converts tag to a chip model
     */
    toChipModel(): SourceChip {
        return {
            label: this.name,
            type: this.typeToStringMap[this.type],
            id: this.id
        };
    }
}
